import { defaults } from 'lodash';

import dev from './environmentDefaults/dev';
import test from './environmentDefaults/test';
import prod from './environmentDefaults/prod';

const envVars = { dev, test, prod } as const;

type AppEnv = keyof typeof envVars;

const resolveEnv = (): AppEnv => {
  const raw = process.env.REACT_APP_ENV;
  if (raw && raw in envVars) {
    return raw as AppEnv;
  }
  console.warn(
    `[config] REACT_APP_ENV="${raw ?? ''}" is missing or invalid; falling back to "prod"`
  );
  return 'prod';
};

const env = resolveEnv();
console.log('REACT_APP_ENV', process.env.REACT_APP_ENV, 'resolved', env);

// Cast through a shared shape so missing optional keys on one env don't
// produce a broken union when consumers destructure config.
export type AppConfig = typeof prod;
export default defaults({}, envVars[env]) as AppConfig;
